import { UserRole } from '@cobliteam/common-types';
import { useUser } from '@cobliteam/hooks';
import { useTranslation } from '@cobliteam/i18n';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import Typography from '@cobliteam/ui/components/Typography';
import { SelectItem } from '@cobliteam/ui/form/Select';
import Icon, { type IconNames } from '@cobliteam/ui/icons';

interface UserRoleSelectOption {
  role: UserRole;
}

interface RoleOptionInfo {
  value: string;
  iconName: IconNames;
  iconClassName: string;
  isDisabled?: boolean;
}

export const useRoleOption = (): { [role in UserRole]: RoleOptionInfo } => {
  const { t } = useTranslation('account');

  return {
    [UserRole.ADMINISTRATOR]: { value: t('user_role_helper.administrator.display_name'), iconName: 'star', iconClassName: 'text-accessory-sky-11' },
    [UserRole.MANAGER]: { value: t('user_role_helper.manager.display_name'), iconName: 'car', iconClassName: 'text-accessory-tomato-11' },
    [UserRole.OPERATION]: { value: t('user_role_helper.operation.display_name'), iconName: 'user-round', iconClassName: 'text-accessory-lime-11' },
    [UserRole.MAP_VIEW]: { value: t('user_role_helper.map_view.display_name'), iconName: 'eye', iconClassName: 'text-accessory-purple-11' },
    [UserRole.USER_INSTALLER]: { value: t('user_role_helper.user_installer.display_name'), iconName: 'hard-drive-upload', iconClassName: 'text-accessory-gold-11' },
    [UserRole.SAFETY_COACHER]: { value: t('user_role_helper.safety_coacher.display_name'), iconName: 'clipboard-list', iconClassName: 'text-accessory-gold-11' },
    [UserRole.COBLER]: { value: '', iconName: 'star', iconClassName: '' },
  };
};

const UserRoleSelectOption = ({ role }: UserRoleSelectOption) => {
  const { getUser } = useUser();
  const roleOption = useRoleOption();
  const user = getUser();
  const optionValues = roleOption[role];
  const isDisabled = role === UserRole.ADMINISTRATOR && user.role !== UserRole.ADMINISTRATOR;

  return (
    <Tooltip enable={isDisabled} content='Somente administradores podem convidar outros administradores.'>
      <SelectItem key={role} value={role} disabled={isDisabled}>
        <div className='flex flex-row items-center justify-start gap-2 align-middle'>
          <Icon name={optionValues.iconName} className={optionValues.iconClassName} />
          <Typography className='font-normal'>{optionValues.value}</Typography>
        </div>
      </SelectItem>
    </Tooltip>
  );
};

export default UserRoleSelectOption;
